// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import awsConfig from '../cfn-output.json';

export const AWS_GRAPHQL2_API_URL = awsConfig.Graph2Endpoint.includes(
  'localhost',
)
  ? `http://${awsConfig.Graph2Endpoint}/graphql`
  : `https://${awsConfig.Graph2Endpoint}/graphql`;
export const AWS_REGION = 'us-east-1';
export const AWS_COGNITO_USER_POOL_ENDPOINT = awsConfig.UserPoolEndpoint;
export const AWS_S3_BUCKET_NAME = awsConfig.MediaServiceBucketName;
export const MEDIA_SERVICE_DOMAIN_NAME = awsConfig.MediaServiceDomainName;
export const OAUTH_CLIENT_ID = 'bjBzUncxeDkxcE04RzM3MUpYWHM6MTpjaQ';
export const PAGE_SCREENSHOT_URL = awsConfig.PageScreenshotLambdaUrl;
export const APP_URL = awsConfig.AppUrl;
export const BASED_ONE_MINI_APP_DOMAIN = awsConfig.BasedOneMiniAppDomain;

export const PUBLIC_API_URL = awsConfig.ApiEndpoint.includes('localhost')
  ? `http://${awsConfig.ApiEndpoint}`
  : `https://${awsConfig.ApiEndpoint}`;

export const COOKIE_SECRET = import.meta.env.COOKIE_SECRET;

export const SCRAPPING_TOURNAMENT_ID = '01JXQE2D4ZAVBR86Z2MW9CMTPG';

export const TERMINAL_HOSTED_ZONE_NAME = awsConfig.TerminalHostedZoneName;

export const PRICE_PROXY_URL = awsConfig.PriceProxyUrl;

export const PRIVY_APP_ID = import.meta.env.VITE_PRIVY_APP_ID;
